import React, { useMemo } from 'react';
import sanitize from 'sanitize-html';

type NewsBodyProps = {
  body: string;
  summaryBody?: string[];
  isFolded: boolean;
  isCheckedSummary: boolean;
};
export const NewsBody = ({ body, isFolded, summaryBody, isCheckedSummary }: NewsBodyProps) => {
  const hasSummary = summaryBody?.length > 0;
  const isHide = hasSummary && isCheckedSummary && isFolded;
  const sanitizedBody = useMemo(() => {
    return sanitize(body, {
      allowedTags: false,
      allowedAttributes: {
        // We don't currently allow img itself by default, but this
        // would make sense if we did. You could add srcset here,
        // and if you do the URL is checked for safety
        iframe: ['src', 'frameborder', 'allow'],
        img: ['src', 'align'],
        td: ['style'],
      },
      allowedSchemes: ['https'],
    });
  }, [body]);

  return (
    <div className={isHide ? 'hidden' : 'block'}>
      {!isHide && isCheckedSummary && hasSummary && (
        <strong className="subTit">
          <i className="icoNewspaper" />
          뉴스 원문
        </strong>
      )}
      <div className="articleView">
        <p className="txt" dangerouslySetInnerHTML={{ __html: sanitizedBody }} />
      </div>
    </div>
  );
};
